// extracted by mini-css-extract-plugin
export var surveyCategory = "survey-session-question-list-module--survey-category---tTLk";
export var surveyCategoryCollapsed = "survey-session-question-list-module--survey-category-collapsed--za1CY";
export var surveyList = "survey-session-question-list-module--survey-list--MGX8E";
export var surveySections = "survey-session-question-list-module--survey-sections--E97Ld";